import { action, computed, observable, makeObservable } from 'mobx';
import { UserTutorialCompletionsApi } from '../../../../apis/userTutorialCompletions';
import { UserTutorialCompletionIndexView, UserTutorialCompletionKey } from '../../../../types/userTutorialCompletions';
import { routingStore } from '../../../../../common/stores/routing';
import { V3Routes } from '../../../../routes';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { ShownUserTutorialApis } from '../../../../apis/showUserTutorials';

export class UserTutorialDetailPaneState {
  completions: RemoteResourceV3<UserTutorialCompletionIndexView[]> = RemoteResourceV3.loading();
  showTutorials: RemoteResourceV3<boolean> = RemoteResourceV3.loading();
  submitting: boolean;

  constructor() {
    makeObservable(this, {
      completions: observable,
      showTutorials: observable,
      submitting: observable,
      loading: computed,
      init: action.bound,
      hasCompleted: action.bound,
      showUserTutorials: action.bound,
      createCompletion: action.bound,
      reloadShownUserTutorial: action.bound,
      reloadUserTutorialCompletions: action.bound,
    });
  }

  get loading() {
    return this.completions.loading || this.showTutorials.loading;
  }

  init() {
    this.reloadUserTutorialCompletions();
    this.reloadShownUserTutorial();
  }

  hasCompleted(key: UserTutorialCompletionKey) {
    return !!this.completions.getOrElse([]).find((completion) => completion.tutorial_key == key);
  }

  showUserTutorials() {
    return this.showTutorials.getOrElse(false);
  }

  async createCompletion(key: UserTutorialCompletionKey) {
    try {
      this.submitting = true;
      await UserTutorialCompletionsApi.create(key);
      await this.reloadUserTutorialCompletions();
      routingStore.push(V3Routes.home());
    } finally {
      this.submitting = false;
    }
  }

  async reloadShownUserTutorial() {
    await updateRemoteResourceV3(
      this.showTutorials,
      (v) => (this.showTutorials = v),
      () => ShownUserTutorialApis.shownTutorials()
    );
  }

  async reloadUserTutorialCompletions() {
    await updateRemoteResourceV3(
      this.completions,
      (v) => (this.completions = v),
      () => UserTutorialCompletionsApi.findAll()
    );
  }
}
